import { FileMetaData } from '../../../../componentsNew/organisms/file-upload/FileUpload';
import api from '../../../../utils/api';
import { StoredFileMetadata } from '../../../shared/types';

export interface FindBankStatements {
    bankStatements: FileMetaData[] | [];
}

export interface FindBankStatementsResponse {
    bankStatements: StoredFileMetadata[] | [];
}

const bankStatementsToStoredFileMetaData = (bankStatements: StoredFileMetadata[] | []): FindBankStatements => {
    return {
        bankStatements: bankStatements.map((bankStatement: StoredFileMetadata) => ({
            name: bankStatement.name,
            size: parseInt(bankStatement.size),
        } as FileMetaData)),
    };
};

const findBankStatements = async (homeseekerId: string): Promise<FindBankStatements> => {
    const response: FindBankStatementsResponse = await api.getWithoutAuth(`api/screening/${homeseekerId}/bank-statements/find`);

    return bankStatementsToStoredFileMetaData(response.bankStatements);
}

export default findBankStatements;
